import { getBookIcon, getBookLogo } from './imageUtils';

const books = {
  30: {
    name: 'DraftKings',
    slogan: 'The Crown is Yours.',
    icon: getBookIcon({ bookId: 30 }),
    logo: getBookLogo({ bookId: 30 }),
    darkIcon: getBookIcon({ bookId: 30, variant: 'dark' }),
  },
  33: {
    name: 'Caesars',
    slogan: 'We Are All Caesars.',
    icon: getBookIcon({ bookId: 33 }),
    logo: getBookLogo({ bookId: 33 }),
    darkIcon: getBookIcon({ bookId: 33, variant: 'dark' }),
  },
  34: {
    name: 'MGM',
    slogan: 'The King of Sportsbooks.',
    icon: getBookIcon({ bookId: 34 }),
    logo: getBookLogo({ bookId: 34 }),
    darkIcon: getBookIcon({ bookId: 34, variant: 'dark' }),
  },
  35: {
    name: 'FanDuel',
    slogan: 'Play Your Game',
    icon: getBookIcon({ bookId: 35 }),
    logo: getBookLogo({ bookId: 35 }),
    darkIcon: getBookIcon({ bookId: 35, variant: 'dark' }),
  },
};

export function getBookAssetsById(id: string) {
  return (
    books[id] ?? {
      name: `Unknown bookId: ${id}`,
      icon: '/assets/default-book-logo.png',
      logo: '/assets/default-book-logo.png',
      darkIcon: '/assets/default-book-logo.png',
    }
  );
}

export function getBookSloganById(id: string) {
  return books[id]?.slogan ?? null;
}
